module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectClients":"Select Clients","selectClientsHint":"Select the clients you want to associate with this item"},"fr":{"selectClients":"Choisir les clients","selectClientsHint":"Choisir les clients que vous souhaitez associer à cet élément"}}')
  delete Component.options._Ctor
}
